import React from 'react';
import { XCircle, Home, ShoppingCart, RefreshCcw } from 'lucide-react';
import { useBrand } from '../context/BrandContext';

const OrderCancelledPage = () => {
  const brand = useBrand();
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center space-y-6">
        {/* Cancelled Icon */}
        <div className="w-20 h-20 bg-slate-100 text-slate-500 rounded-full flex items-center justify-center mx-auto">
          <XCircle size={40} />
        </div>

        {/* Message */}
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Checkout Cancelled</h1>
          <p className="text-slate-600 mt-2">
            Your order was not completed. No payment has been charged.
          </p>
        </div>

        {/* Info */}
        <div className="p-4 bg-slate-50 rounded-xl text-left">
          <p className="text-sm text-slate-600">
            Your cart items are still saved. You can return to checkout anytime to complete your purchase.
          </p>
        </div>

        {/* Actions */}
        <div className="space-y-3 pt-4">
          <a
            href="/"
            className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
          >
            <ShoppingCart className="w-5 h-5" />
            Return to Products
          </a>

          <button
            onClick={() => window.history.back()}
            className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 border border-slate-200 text-slate-700 font-semibold rounded-lg hover:bg-slate-50 transition-colors"
          >
            <RefreshCcw className="w-5 h-5" />
            Try Again
          </button>
        </div>

        {/* Help Link */}
        <p className="text-sm text-slate-500">
          Having trouble?{' '}
          <a href={`mailto:${brand?.legal?.supportEmail || 'support@merchlike.com'}`} className="text-blue-600 hover:underline">
            Contact support
          </a>
        </p>
      </div>
    </div>
  );
};

export default OrderCancelledPage;
